<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Predictile Roles</h3>
      <div class="tw-grid tw-grid-cols-1 tw-gap-3 tw-py-2 tw-px-3" v-if="isLoading">
        <div v-for="i in 3" :key="`role-skeleton-loader-${i}`" class="tw-flex tw-items-center">
          <base-skeleton-loader class="tw-h-4 tw-w-4" />
          <base-skeleton-loader class="tw-h-3 tw-my-1 tw-w-24 tw-ml-3" />
        </div>
      </div>
      <div class="tw-grid tw-grid-cols-1 tw-gap-3 tw-py-2 tw-px-3" v-else>
        <base-checkbox label="Administrator" value="predictile_administrator" v-model="roles" />
        <base-checkbox label="Management" value="predictile_management" v-model="roles" />
        <base-checkbox label="Operations" value="predictile_operations" v-model="roles" />
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse">
        <base-button @click="save" :loading="isSaving" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="add-business-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import EventBus from "@/utils/global-events.js";

export default {
  components: {
    InlineError,
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      userId: null,
      roles: [],
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    show(userId) {
      this.userId = userId;
      this.$refs.modal.show();
      this.load();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async load() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/predictile/users/${this.userId}/roles`);
        this.roles = response.data.roles;
      } catch (err) {
        this.errorTitle = "Error loading roles";
        this.errorMessage = "Sorry, we had trouble loading the roles for this user. The technicians have been notified. Please try again.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      try {
        this.isSaving = true;
        await this.$axios.put(`/predictile/users/${this.userId}/roles`, {
          roles: this.roles,
        });
        this.hide();
        EventBus.$emit("GLOBAL_NOTIFY", { title: "Success", message: "Roles updated successfully!" });
      } catch (err) {
        this.errorTitle = "Error saving roles";
        this.errorMessage = "Sorry, we had trouble saving the roles for this user. The technicians have been notified. Please try again.";
        this.error = err;
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
